import React from 'react'
import styled from 'styled-components'

const Style = styled.div`
  border-radius: 10px;
  background-color: #ffe8d0;
  display: inline-flex;
  padding: 7px;
  font-family: 'Open Sans';
  margin-right: 5px;
  margin-bottom: 5px;

  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #e96000;
`

const Badge = ({ children = '' }) => {
  return <Style>{children}</Style>
}

export default Badge
